module.exports = __webpack_public_path__ + "img/sandbox-1.a409e221.png";